// extracted by mini-css-extract-plugin
module.exports = {"host":"nav-cart_host__tGQTt"};